import Button from "../components/Button.js";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="page-not-found">
      <img
        // className="page-not-found-image"
        src={logo}
        style={{ width: "96px" }}
      />
      <h1 style={{ textAlign: "center" }}>Opss, Page not found!</h1>
      <Button text="BACK TO HOME" onClick={() => navigate("/")} />
    </div>
  );
};

export default PageNotFound;
